<main class="grid-container site-container site-container--error-page" id="content">
  <div class="grid-x grid-margin-x">
      <div class="cell">
        <h1 class="secondary" >
          {{ title ? title : "Sorry, something went wrong with " + errorProvider.applicationName + " (500 error)" }}
        </h1>
        <div
          [innerHTML]="description ? description : 'It\'s nothing you\'ve done. We\'re working on a fix for this.' | dontSanitizeHtml">
        </div>
        <ng-content select="[extraContentLower]"></ng-content>
      </div>
  </div>
</main>
